var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "white-space": "normal"
    }
  }, [_vm._l(_vm.status, function (value, key, i) {
    return [value !== null ? _c('KeyValue', {
      staticClass: "d-inline-block",
      style: {
        width: _vm.width
      },
      attrs: {
        "k": key,
        "v": _vm.formatValue(value)
      }
    }) : _c('div', {
      staticClass: "d-inline-block",
      style: {
        width: _vm.width
      }
    }), (i + 1) % _vm.divide != 0 ? _c('div', {
      staticClass: "d-inline-block",
      staticStyle: {
        "width": "8px"
      }
    }) : _vm._e()];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }